<template>
  <div class="product-section">
    <div class="df vertical df-around">
      <div class="title">
        {{ requestPayload.localDate }} 本工序质检问题
      </div>
    </div>

    <div class="df both-side" style="margin-top: 20px">
      <a-table :columns="reworkColumns" :data-source="tableData" :pagination="false" :rowClassName="(record, index) => (index % 1 === 0 ? 'table-striped' : null)
        " rowKey="id" bordered style="width: calc(100vw - 160px); margin: 0 auto"
        :scroll="{ x: 'calc(100vw - 160px)' }">
        <template #question1="{ record }">
          <div v-for="(img, index) in record.issuesImg1" :key="index">
            <a-image :width="50" :src="img" />
          </div>
          <div v-for="(video, index) in record.issuesVideo1" :key="index">
            <video :src="video" controls width="120" :key="video"></video>
          </div>
          <div v-for="(item, index) in record.issuesDesc1" :key="index">
            {{ item }}
          </div>
        </template>
        <template #questionType1="{ record }">
          <div v-if="record.questionType1">
            <div v-for="(item, index) in record.questionType1" :key="index">
              {{ item }}
            </div>
          </div>
        </template>

        <template #sourceProcess="{ record }">
          {{ getProcessName(record.sourceProcess) }}
        </template>

        <template #type="{ record }">
          {{ getProcessName(record.type) }}
        </template>

        <template #question2="{ record }">
          <div v-for="(img, index) in record.issuesImg2" :key="index">
            <a-image :width="50" :src="img" />
          </div>
          <div v-for="(video, index) in record.issuesVideo2" :key="index">
            <video :src="video" controls width="120" :key="video"></video>
          </div>
          <div v-for="(item, index) in record.issuesDesc2" :key="index">
            {{ item }}
          </div>
        </template>
        <template #questionType2="{ record }">
          <div v-if="record.questionType2">
            <div v-for="(item, index) in record.questionType2" :key="index">
              {{ item }}
            </div>
          </div>
        </template>
        <template #reason1="{ record }">
          <div v-if="record.reason1">
            <div v-for="(item, index) in record.reason1" :key="index">
              {{ item }}
            </div>
          </div>
        </template>
        <template #reason2="{ record }">
          <div v-if="record.reason2">
            <div v-for="(item, index) in record.reason2" :key="index">
              {{ item }}
            </div>
          </div>
        </template>
        <template #solution1="{ record }">
          <div v-if="record.solution1">
            <div v-for="(item, index) in record.solution1" :key="index">
              {{ item }}
            </div>
          </div>
        </template>
        <template #solution2="{ record }">
          <div v-if="record.solution2">
            <div v-for="(item, index) in record.solution2" :key="index">
              {{ item }}
            </div>
          </div>
        </template>
        <template #notes="{ record }">
          <div v-if="record.notes">
            <template v-for="(item, index) in JSON.parse(record.notes)" :key="index">
              <a-image v-for="img in JSON.parse(item.picture)" :key="img" :width="50" :src="img" />

              <video v-for="video in JSON.parse(item.video)" :src="video" controls width="120" :key="video"></video>

              <div>
                {{ item.desc }}
              </div>
            </template>
          </div>
        </template>

        <template #closedLoopStatus="{ record }">
          <closed-loop-status :closedLoopStatus="record.closedLoopStatus"></closed-loop-status>
        </template>

        <template #action="{ record }">
          <a-button @click="handleEdit(record)" size="small">编辑</a-button>
        </template>
      </a-table>
    </div>

    <pqc-form ref="pqcformRef" :type="props.type" @updateTable="handleSearch"></pqc-form>
  </div>
</template>

<script>
import { computed, defineComponent, inject, reactive, ref, watch } from "vue";
import { getPQCList } from "@/request/view/dailyQualityInspection";
import { debounce, timeStampToTime } from "@/utils";
import { columns } from "@/views/productDaily/components/quality/PQC/serve/option";
import { getProcessName } from "@/views/productDaily/serve/option";
import pqcForm from "@/views/productDaily/components/product/components/qualityInspection/form.vue";

export default defineComponent({
  props: {
    type: String,
    produceOrTpc: String,
  },
  components: {
    pqcForm,
  },
  setup(props, context) {
    const pqcformRef = ref();

    const cascadeDate = inject("cascadeDate", ref(null));
    const reworkColumns = computed(() => {
      const copyColumns = JSON.parse(JSON.stringify(columns));
      copyColumns.splice(5, 2, {
        align: "center",
        slots: {
          customRender: "type",
        },

        title: "工序",
        width: 120,
      });
      return copyColumns;
    });
    /**
     * 请求参数
     */
    const requestPayload = reactive({
      status: "不合格",
      startDate: null,
      endDate: null,
      inspectionFrequency: null,
      localDate: timeStampToTime("", "upload"),
      modelSpecifications: null,
      produceOrTpc: props.produceOrTpc,
      questionType: null,
      search: null,
      sourceProcess: props.type,
      type: null,
    });

    const tableData = reactive([]);
    // 设置渲染数据
    const setmediaInfo = (list) => {
      if (!list) return;
      list.forEach((item) => {
        if (
          item.inspectionIssues &&
          item.inspectionIssues.indexOf("[") !== -1
        ) {
          const list = JSON.parse(item.inspectionIssues);
          if (typeof list === "object")
            list.forEach((issues, index) => {
              item[`issuesDesc${index + 1}`] = [];
              item[`issuesImg${index + 1}`] = [];
              item[`issuesVideo${index + 1}`] = [];
              item[`questionType${index + 1}`] = [];
              item[`solution${index + 1}`] = [];
              item[`reason${index + 1}`] = [];
              issues.list.forEach((media) => {
                item[`issuesImg${index + 1}`].push(
                  ...JSON.parse(media.picture)
                );
                item[`issuesVideo${index + 1}`].push(
                  ...JSON.parse(media.video)
                );
                item[`questionType${index + 1}`].push(media.type);
                item[`issuesDesc${index + 1}`].push(media.desc);
                item[`solution${index + 1}`].push(media.solution);
                item[`reason${index + 1}`].push(media.reason);
              });
              item[`inspectionPersonnel${index + 1}`] =
                issues.inspectionPersonnel;
              item[`qualityPersonnel${index + 1}`] = issues.qualityPersonnel;
            });
        }
      });
    };
    // 获取PQC数据
    const getPQCData = () => {
      getPQCList(requestPayload)
        .then((res) => {
          tableData.length = 0;
          if (res.code === 200 && res.message === "成功" && res.data) {
            try {
              Object.keys(res.data).forEach((key) => {
                setmediaInfo(res.data[key]);
                tableData.push(...res.data[key]);
              });
            } catch (error) {
              console.log(error, "捕获到的错误是什么");
            }
          }
        })
        .catch((err) => { });
    };

    // 获取PQC 和 合格率数据
    const getData = () => {
      getPQCData();
    };

    // 搜索数据
    const handleSearch = debounce(() => {
      getData();
    }, 100);

    // 编辑数据
    const handleEdit = (data) => {
      pqcformRef.value.openModal("editPQC", data);
    };

    watch(
      () => cascadeDate,
      (val) => {
        if (!val.value) return;
        const date = val.value.format("YYYY-MM-DD");
        if (requestPayload.localDate !== date) {
          requestPayload.localDate = date;
        }
        getData();
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      columns,
      reworkColumns,
      tableData,
      pqcformRef,
      requestPayload,
      handleSearch,
      handleEdit,
      getProcessName,
    };
  },
});
</script>

<style lang="less" scoped></style>
